// Copyright (c) 2019 AppJudo Inc.  MIT License.

import pluralize from 'pluralize';
import strings from 'common/strings';

const ACRONYM_REGEXP = /^[A-Z]+$/;

export const VIN_LAST_LENGTH = 17;
export const STOCK_LAST_LENGTH = 8;

export function quantify(quantity: number, singularUnit: string): string {
  return `${quantity} ${getUnitForQuantity(quantity, singularUnit)}`;
}

export function getUnitForQuantity(
  quantity: number,
  singularUnit: string
): string {
  if (quantity === 1) {
    return singularUnit;
  }
  if (ACRONYM_REGEXP.test(singularUnit)) {
    return singularUnit + 's';
  }
  return pluralize.plural(singularUnit);
}

export function truncateEndOfStringByLength(
  string: string,
  length: number,
  emptyValue: string = strings.EMPTY_VALUE
) {
  return string
    ? string.length <= length
      ? string
      : `...${string.slice(0 - length)}`
    : emptyValue;
}

export function truncateEllipsis(
  string: string,
  length: number,
  ellipsis = '...'
) {
  return string.length > length ? string.slice(0 - length) + ellipsis : string;
}

export function truncateEllipsisMiddle(str: string, maxLength: number = 30) {
  if (str.length > maxLength) {
    const partSize = (maxLength - 2) / 2;
    return (
      str.substr(0, partSize) +
      '...' +
      str.substr(str.length - partSize, str.length)
    );
  }
  return str;
}
